import { FULL_PERCENT } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { fetchHistoryCheckAwtgRanBranches } from '@api/hitoryCheck';

import { TAwtgRanBranches } from '@interfaces/cmModule/cmModule';
import { TAwtgRanProgressResponse } from '@interfaces/cmModule/dto/historyCheckDTO';
import { TDefaultDTO } from '@interfaces/common/defaultDTO';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_AWTG_RAN_BRANCHES_FETCH } from '@constants/queryKeys';

type TUseQueryHistoryCheckAwtgRanBranches = TDefaultDTO & {
	vendor?: string;
	progress?: TAwtgRanProgressResponse;
	progressId?: string;
}

export const useQueryHistoryCheckAwtgRanBranches = (params: TUseQueryHistoryCheckAwtgRanBranches) => {
	const {
		vendor,
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		searchValue,
		progressId,
		progress,
	} = params;

	const isAwtgRanVendor = vendor === EVendorsValues.oran;
	const dumpId = progress?.dumpId || null;
	const isFullProgress = progressId === progress?.id && progress?.percentsProgress === FULL_PERCENT;

	const {
		data: branchData,
		isLoading: isLoadingBranchData,
		isFetching: isFetchingBranchData,
	} = useQuery<TAwtgRanBranches | undefined>({
		queryKey: [
			HISTORY_CHECK_AWTG_RAN_BRANCHES_FETCH,
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			dumpId,
			progressId,
			progress,
		],
		queryFn: () => {
			if (isFullProgress) {
				return fetchHistoryCheckAwtgRanBranches({
					pageSize,
					page,
					sortDirection,
					sortFieldName,
					searchValue,
					dumpHistoryId: dumpId!,
				});
			}
		},
		enabled: [
			!!dumpId,
			!!pageSize,
			!!page,
			isFullProgress,
			isAwtgRanVendor,
		],
		...refetchOptions,
	});

	return {
		branchData,
		isLoadingBranchData: (isLoadingBranchData && !!branchData)
			|| isFetchingBranchData,
		isFetchingBranchData,
	};
};
